module.exports = __webpack_public_path__ + "img/MapThumb_ResourceWar.0657360b.webp";